import { Link, useSearchParams } from "react-router-dom";

import { T } from "@repo/transifex";
import { ErrorDisplay } from "~/components/collect/error-display";

import { OrderDetailsPageLayout } from "../__app.collect.orders/order-details-page-layout";
import { UserInfoContainer } from "../__app.collect.orders/user-info-container";

import { OrdersCreateContainer } from "./orders-create-container";

export const CollectChildOrderCreatePage = () => {
  const [searchParams] = useSearchParams();
  const childId = searchParams.get("childId");
  const groupName = searchParams.get("groupName");

  if (!childId || !groupName) {
    return (
      <ErrorDisplay>
        <ErrorDisplay.Title>
          <T _str="Something went wrong!" />
        </ErrorDisplay.Title>
        <ErrorDisplay.Description>
          <T _str="We couldn’t find the user" />
        </ErrorDisplay.Description>
        <Link to="/collect">
          <ErrorDisplay.Action variant="danger">
            <T _str="Go back" />
          </ErrorDisplay.Action>
        </Link>
      </ErrorDisplay>
    );
  }

  return (
    <OrderDetailsPageLayout
      className="flex size-full flex-1 flex-row bg-interface-neutral-2"
      leftColumn={<UserInfoContainer childId={childId} />}
      rightColumn={
        <OrdersCreateContainer childId={childId} groupName={groupName} />
      }
    />
  );
};
